import { useEffect, useState } from 'react';
import { createArray } from '../utils/array';
import { useSession } from '../components/video/session-provider/session-provider';
var TILE_MARGIN = 8;
var TILE_HEIGHT = 162 + 2 * TILE_MARGIN;
var MOBILE_TILE_MARGIN = 4;
var MOBILE_TILE_WIDTH = 70 + 2 * MOBILE_TILE_MARGIN;
export var useFocusedLayout = function (mobile, width, height, attendees, focusedAttendeeId) {
    var _a = useState(0), pagesCount = _a[0], setPagesCount = _a[1];
    var _b = useState(0), currentPage = _b[0], setCurrentPage = _b[1];
    var _c = useState([]), visibleAttendeeIds = _c[0], setVisibleAttendeeIds = _c[1];
    var sharingAttendeeId = useSession().sharingAttendeeId;
    useEffect(function () {
        var count = getPagesCount(mobile, width, height, focusedAttendeeId && !sharingAttendeeId ? attendees.length - 1 : attendees.length);
        setPagesCount(count);
        if (count > 0 && currentPage > count - 1) {
            setCurrentPage(count - 1);
        }
    }, [mobile, width, height, attendees, focusedAttendeeId, sharingAttendeeId]);
    useEffect(function () {
        setVisibleAttendeeIds(getVisibleAttendeeIds(mobile, width, height, attendees, focusedAttendeeId, currentPage, sharingAttendeeId));
    }, [mobile, width, height, attendees, focusedAttendeeId, currentPage, sharingAttendeeId]);
    return {
        pagesCount: pagesCount,
        currentPage: currentPage,
        visibleAttendeeIds: visibleAttendeeIds,
        setCurrentPage: setCurrentPage,
    };
};
var getVisibleTilesCount = function (mobile, width, height) {
    return (mobile
        ? Math.floor((width - 2 * MOBILE_TILE_MARGIN) / MOBILE_TILE_WIDTH)
        : Math.floor((height + 2 * TILE_MARGIN) / TILE_HEIGHT)) || 1;
};
var getPagesCount = function (mobile, width, height, attendeesCount) {
    return Math.ceil(attendeesCount / getVisibleTilesCount(mobile, width, height));
};
var getVisibleAttendeeIds = function (mobile, width, height, attendees, focusedAttendeeId, currentPage, sharingAttendeeId) {
    if (!attendees.length) {
        return [];
    }
    var visibleTilesCount = getVisibleTilesCount(mobile, width, height);
    var nonFocusedAttendees = sharingAttendeeId
        ? attendees
        : attendees.filter(function (attendeeId) { return attendeeId !== focusedAttendeeId; });
    return createArray(visibleTilesCount)
        .map(function (_, index) { return index + currentPage * visibleTilesCount; })
        .map(function (index) { return nonFocusedAttendees[index]; });
};
//# sourceMappingURL=focused-layout.js.map